import type {IconName} from '@lightricks/react-design-system';
import type {PlatformId} from '@/types/models/creator-crm/filterId';

const ICON_SIZE_OVERRIDES = {
  small: {
    width: 14,
    height: 12,
  },
  medium: {
    width: 22,
    height: 18,
  },
  large: {
    width: 28,
    height: 24,
  },
} as {[key: string]: {small?: object; medium?: object; large?: object}};

// eslint-disable-next-line import/prefer-default-export
export function platformIdToPlatformIconProps(
  platformId: PlatformId | 'all',
  iconSize: 'small' | 'medium' | 'large'
): {
  iconName: IconName | undefined;
  iconStyle?: {small?: object; medium?: object; large?: object};
} {
  switch (platformId) {
    case 'all':
      return {
        iconName: 'Navigation-Grid',
        iconStyle: ICON_SIZE_OVERRIDES[iconSize],
      };
    case 'facebook':
      return {iconName: 'Social-Facebook'};
    case 'instagram':
      return {iconName: 'Social-Instagram'};
    case 'pinterest':
      return {iconName: 'Social-Pinterest'};
    case 'tiktok':
      return {iconName: 'Social-TikTok'};
    case 'youtube':
      return {iconName: 'Social-YouTube'};
    case 'twitter':
      return {iconName: 'Social-X'};
    default:
      return {iconName: undefined};
  }
}
